export const SERVICE_ORDER_CONFIRMATION_ERROR =
  'Não foi possível enviar a confirmação o agendamento, tente novamente mais tarde'
